// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-collapse/assets/index.css
 ** module id = 167
 ** module chunks = 0
 **/